"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import React from "react";

import { Button, TypoGraph } from "@/components/ui/primitives";
import { Retry } from "@/components/ui/primitives/icons";
import { ROUTES } from "@/config/routes/paths";

const NotFound = () => {
  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  const handleGoHome = () => {
    router.push(ROUTES.CLIENT.LIST);
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="flex flex-col gap-6 items-center w-[616px] h-[228px]">
        <div className="flex items-center gap-8">
          <Image src="/images/not_found.svg" alt="404" width={160} height={160} />
          <div className="flex flex-col gap-2 w-full">
            <div className="flex w-[72px] h-[50px] justify-center items-center">
              <TypoGraph variant="title01" className="text-primary-900">
                404
              </TypoGraph>
            </div>
            <div className="flex h-[26px] w-full justify-center items-center">
              <TypoGraph variant="headline03" className="text-gray-900">
                죄송합니다. 현재 찾을 수 없는 페이지에 접속하셨습니다.
              </TypoGraph>
            </div>
            <div className="flex flex-col h-[44px] w-[291px] justify-center">
              <TypoGraph variant="body02">
                삭제되거나 주소가 잘못 입력되었습니다.
              </TypoGraph>
              <TypoGraph variant="body02">
                이전 페이지로 돌아가거나, 홈페이지로 이동해 주세요
              </TypoGraph>
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <Button variant="secondary" onClick={handleGoBack} leftIcon={<Retry className="text-gray-900" />}>
            이전 페이지
          </Button>
          <Button variant="outlinedSecondary" onClick={handleGoHome}>
            홈페이지로 이동
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
